// extracted by mini-css-extract-plugin
module.exports = {"container":"SyncShopify_container__2i_dZ"};